import React, { Component } from "react";
import axios from "axios";
import { renderMarkup } from "../utils.js";
import edge from "../assets/edge.svg";

export default class Single extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  componentDidMount() {
    const SITE_URL = "https://oncourse.dev-ggmm.com",
      { id } = this.props.match.params;

    axios.get(SITE_URL + "/wp-json/wp/v2/pages?slug=" + id).then(res => {
      this.setState(
        {
          data: res.data[0]
        },
        () => window.scrollTo(0, 0)
      );
    });
  }

  convertDate(date) {
    const removeTime = date.substring(0, date.indexOf("T"));
    const p = removeTime.split(/\D/g);
    return [p[1], p[2], p[0]].join("-");
  }

  convertToSlug(Text) {
    return Text.toLowerCase()
      .replace(/ /g, "-")
      .replace(/&/g, "and")
      .replace(/[^\w-]+/g, "");
  }

  componentDidUpdate() {
    window.scrollTo(0, 0);
  }

  render() {
    const { data } = this.state;
    if (!data) {
      return <div>Loading...</div>;
    } else {
      return (
        <div className="post">
          <div className="post-hero bg-gray">
            <img className="edge left" src={edge} alt="Edge Element" />
            <img className="edge right" src={edge} alt="Edge Element" />

            <div className="container">
              <h1>{data.title.rendered}</h1>
            </div>
          </div>
          <div
            className="post-content wrapper inner"
            dangerouslySetInnerHTML={renderMarkup(data.content.rendered)}
          />
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Single.js